var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('supplier-form',{attrs:{"init-supplier":{ min_order_sum: '', country: 'Österreich', category: null, tags: [] },"val-errors":_vm.valErrors,"submit-text":"Erstellen"},on:{"submit":_vm.submit}})}
var staticRenderFns = []

export { render, staticRenderFns }